var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "tile is-child box has-sticky-tile",
      staticStyle: { "margin-bottom": "1rem !important" },
    },
    [
      _c(
        "div",
        {
          staticClass: "is-flex is-align-items-center",
          staticStyle: { height: "60px" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "toggle-buttons-vertical ml-2 is-flex is-flex-direction-column mt-2 mb-1",
            },
            [
              _c(
                "span",
                {
                  staticClass: "button m-0",
                  class: { "is-primary is-selected": _vm.selectedType === 0 },
                  staticStyle: { "border-radius": "5px 5px 0px 0px" },
                  on: {
                    click: function ($event) {
                      return _vm.changeType(0)
                    },
                  },
                },
                [_c("span", [_vm._v("Job Invoiced This Month")])]
              ),
              _c(
                "span",
                {
                  staticClass: "button m-0",
                  class: { "is-primary is-selected": _vm.selectedType === 1 },
                  staticStyle: { "border-radius": "0px 0px 5px 5px" },
                  on: {
                    click: function ($event) {
                      return _vm.changeType(1)
                    },
                  },
                },
                [_c("span", [_vm._v("Job Invoiced Year to Date")])]
              ),
            ]
          ),
          _vm.selectedType === 0
            ? _c(
                "div",
                {
                  staticClass:
                    "is-flex is-flex-direction-row is-justify-content-space-evenly",
                  staticStyle: { height: "60px", width: "100%" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-flex-direction-column is-align-items-center",
                    },
                    [
                      _c("span", { staticClass: "mt-1 header-text-divider" }, [
                        _vm._v("Total Jobs"),
                      ]),
                      !_vm.isLoading
                        ? _c(
                            "span",
                            { staticClass: "is-size-4 has-text-weight-bold" },
                            [_vm._v(_vm._s(_vm.totalJobs))]
                          )
                        : _c("div", { staticClass: "spins" }, [
                            _c("span", { staticClass: "mdi mdi-loading" }),
                          ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-flex-direction-column is-align-items-center",
                    },
                    [
                      _c("span", { staticClass: "mt-1 header-text-divider" }, [
                        _vm._v("Working Days"),
                      ]),
                      !_vm.isLoading
                        ? _c(
                            "span",
                            { staticClass: "is-size-4 has-text-weight-bold" },
                            [_vm._v(_vm._s(_vm.monthlyWorkingDays))]
                          )
                        : _c("div", { staticClass: "spins" }, [
                            _c("span", { staticClass: "mdi mdi-loading" }),
                          ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-flex-direction-column is-align-items-center",
                    },
                    [
                      _c("span", { staticClass: "mt-1 header-text-divider" }, [
                        _vm._v("Daily Target"),
                      ]),
                      !_vm.isLoading
                        ? _c(
                            "span",
                            { staticClass: "is-size-4 has-text-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  this.$filters.formatCurrency(
                                    _vm.dailyTarget,
                                    this.$userInfo.locale
                                  )
                                )
                              ),
                            ]
                          )
                        : _c("div", { staticClass: "spins" }, [
                            _c("span", { staticClass: "mdi mdi-loading" }),
                          ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-flex-direction-column is-align-items-center",
                    },
                    [
                      _c("span", { staticClass: "mt-1 header-text-divider" }, [
                        _vm._v("Amount Waiting in JCNI"),
                      ]),
                      !_vm.isLoading
                        ? _c(
                            "span",
                            { staticClass: "is-size-4 has-text-weight-bold" },
                            [_vm._v(_vm._s(_vm.totalNotInvoiced))]
                          )
                        : _c("div", { staticClass: "spins" }, [
                            _c("span", { staticClass: "mdi mdi-loading" }),
                          ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-flex-direction-column is-align-items-center",
                    },
                    [
                      _c("span", { staticClass: "mt-1 header-text-divider" }, [
                        _vm._v("Monthly Target"),
                      ]),
                      !_vm.isLoading
                        ? _c(
                            "span",
                            { staticClass: "is-size-4 has-text-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  this.$filters.formatCurrency(
                                    _vm.monthlyTarget,
                                    this.$userInfo.locale
                                  )
                                )
                              ),
                            ]
                          )
                        : _c("div", { staticClass: "spins" }, [
                            _c("span", { staticClass: "mdi mdi-loading" }),
                          ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-flex-direction-column is-align-items-center",
                    },
                    [
                      _c("span", { staticClass: "mt-1 header-text-divider" }, [
                        _vm._v("Invoiced Amount (MTD)"),
                      ]),
                      !_vm.isLoading
                        ? _c(
                            "span",
                            { staticClass: "is-size-4 has-text-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  this.$filters.formatCurrency(
                                    _vm.totalAmount,
                                    this.$userInfo.locale
                                  )
                                )
                              ),
                            ]
                          )
                        : _c("div", { staticClass: "spins" }, [
                            _c("span", { staticClass: "mdi mdi-loading" }),
                          ]),
                    ]
                  ),
                ]
              )
            : _c(
                "div",
                {
                  staticClass:
                    "is-flex is-flex-direction-row is-justify-content-space-evenly",
                  staticStyle: { height: "60px", width: "100%" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-flex-direction-column is-align-items-center",
                    },
                    [
                      _c("span", { staticClass: "mt-1 header-text-divider" }, [
                        _vm._v("Daily Target"),
                      ]),
                      !_vm.isLoading
                        ? _c(
                            "span",
                            { staticClass: "is-size-4 has-text-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  this.$filters.formatCurrency(
                                    _vm.dailyTargetYTD,
                                    this.$userInfo.locale
                                  )
                                )
                              ),
                            ]
                          )
                        : _c("div", { staticClass: "spins" }, [
                            _c("span", { staticClass: "mdi mdi-loading" }),
                          ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-flex-direction-column is-align-items-center",
                    },
                    [
                      _c("span", { staticClass: "mt-1 header-text-divider" }, [
                        _vm._v("Yearly Target"),
                      ]),
                      !_vm.isLoading
                        ? _c(
                            "span",
                            { staticClass: "is-size-4 has-text-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  this.$filters.formatCurrency(
                                    _vm.yearlyTarget,
                                    this.$userInfo.locale
                                  )
                                )
                              ),
                            ]
                          )
                        : _c("div", { staticClass: "spins" }, [
                            _c("span", { staticClass: "mdi mdi-loading" }),
                          ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-flex-direction-column is-align-items-center",
                    },
                    [
                      _c("span", { staticClass: "mt-1 header-text-divider" }, [
                        _vm._v(
                          "Invoiced YTD (FY " + _vm._s(_vm.fiscalYearName) + ")"
                        ),
                      ]),
                      !_vm.isLoading
                        ? _c(
                            "span",
                            { staticClass: "is-size-4 has-text-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  this.$filters.formatCurrency(
                                    _vm.totalAmount,
                                    this.$userInfo.locale
                                  )
                                )
                              ),
                            ]
                          )
                        : _c("div", { staticClass: "spins" }, [
                            _c("span", { staticClass: "mdi mdi-loading" }),
                          ]),
                    ]
                  ),
                ]
              ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }